interface IconProps {
  size?: number;
  className?: string;
}

export function MangoIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="mangoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFD700", stopOpacity: 1 }} />
          <stop offset="60%" style={{ stopColor: "#FF8C00", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#FF4500", stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="leafGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#2E8B57", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#006400", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path d="M50 85C30 85 15 70 15 50C15 30 35 15 55 15C75 15 85 35 85 55C85 75 70 85 50 85Z" fill="url(#mangoGradient)" />
      <path d="M55 15C55 10 52 5 48 5" stroke="#5D4037" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M55 15C65 5 75 8 80 12C75 22 65 22 55 15Z" fill="url(#leafGradient)" />
      <ellipse cx="35" cy="35" rx="8" ry="12" fill="white" fillOpacity="0.2" transform="rotate(-20, 35, 35)" />
    </svg>
  );
}

export function SankeyIcon({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="2" y="4" width="3" height="16" rx="1" fill="currentColor" />
      <path d="M5 7C10 7 14 5 19 5" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" opacity="0.8" />
      <path d="M5 12C10 12 14 12 19 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.6" />
      <path d="M5 17C10 17 14 19 19 19" stroke="currentColor" strokeWidth="4.5" strokeLinecap="round" opacity="0.4" />
      <rect x="19" y="3" width="3" height="4" rx="1" fill="currentColor" />
      <rect x="19" y="10" width="3" height="4" rx="1" fill="currentColor" />
      <rect x="19" y="17" width="3" height="4" rx="1" fill="currentColor" />
    </svg>
  );
}

export function PricegraphIcon({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M3 19H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M3 15L8 10L13 13L21 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="8" cy="10" r="1.5" fill="currentColor" />
      <circle cx="13" cy="13" r="1.5" fill="currentColor" />
      <circle cx="21" cy="5" r="1.5" fill="currentColor" />
    </svg>
  );
}

export function VolumeGraphIcon({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="4" y="12" width="4" height="8" rx="1" fill="currentColor" />
      <rect x="10" y="6" width="4" height="14" rx="1" fill="currentColor" />
      <rect x="16" y="10" width="4" height="10" rx="1" fill="currentColor" />
      <path d="M2 20H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
